export const BRANCH_CLIPBOARD_DEEPVIEW = 'branch_clipboard_deepview';
export const REDIRECT_DOMAINS_WHITELIST = 'redirect_domains_whitelist';
export const BYPASS_TEMP_DISABLED_ATTRIBUTION_PROVIDERS = 'bypass_temp_disabled_attribution_providers'; // remove
export const EO_MIGRATION = 'eo_migration';
export const EO_OPTED_OUT_LIST = 'eo_opted_out_list';
export const IMPRESSIONS = 'impressions'; // remove
export const INSTALL_FRAUD = 'install_fraud';
export const VIEW_ALL_AD_PARTNERS = 'view_all_ad_partners';
export const FORCE_EO_HIDE_TRANSITION_ELEMENTS = 'force_eo_hide_transition_elements';
export const PBA_LIVEVIEW = 'pba_liveview'; // remove
export const FRAUD_PAGE = 'fraud_page'; // remove
export const EVENT_INGESTION = 'event_ingestion'; // remove
export const DESKTOP_LINK_SETTINGS = 'desktop_link_settings'; // remove
export const COHORTS = 'cohorts'; // remove
export const TWITTER_ONBOARDING = 'twitter_onboarding';
export const ORGANIZATION = 'organization'; // remove
export const SHOW_TUNE_LINK_CREATOR = 'show_tune_link_creator';
export const DISPLAY_USER_API_KEY = 'display_user_api_key';
export const CUSTOM_EXPORTS = 'custom_exports';
export const CUSTOM_EXPORTS_TUNE = 'custom_exports_tune'; // ON => TUNE fields and topics; OFF => Branch fields and topics for CEUI
export const JOURNEY_IFRAME_STYLE = 'journey_iframe_style';
export const INSTALL_TOUCH_ATTRIBUTION = 'install_touch_attribution';
export const AD_ACCOUNT_AUTHENTICATION_MESSAGE = 'ad_account_authentication_message';
export const TWO_YEAR_DATA_RETENTION = 'two_year_data_retention';
export const FRAUD_RULE_BUILDER_PAGE = 'fraud_rule_builder_page';
export const FRAUD_RULE_EDITABLE = 'fraud_rule_editable';
export const WHITELISTED_DEVICES = 'whitelisted_devices';
export const HLL_SKETCH_UNIQUES = 'hll_sketch_uniques';
export const DISCOVERY_ADS_UI = 'discovery_ads_ui';
export const ADNETWORKDATAFILTERING = 'adnetworkdatafiltering';
export const RECENT_ACTIVITY_TAB = 'recent_activity_tab';
export const POSTBACK_TESTING = 'postback_testing';
export const EMAIL_DOMAIN_BLACKLIST = 'email_domain_blacklist';
export const NON_SANS_DATA_SHARING_TOGGLE = 'non_sans_data_sharing_toggle';
export const QLC_REDESIGN = 'qlc_redesign';
export const ALLOW_EO_SAN_TOUCH_EXPORT = 'allow_eo_san_touch_export';
export const ENGAGEMENT_BUILDER = 'engagement_builder';
export const LIMITED_DATA_USE = 'limited_data_use';
export const USE_CUSTOM_DOMAIN_FOR_AD_LINK = 'use_custom_domain_for_ad_link';
export const EVENTS_AND_ALIASES_TOPN = 'events_and_aliases_topn';
export const ROKU_SAN = 'roku_san';
export const SHORTER_DEFAULT_DRUID_QUERY_DURATION = 'shorter_default_druid_query_duration';
export const SKADNETWORK_SCREEN_ENABLED = 'skadnetwork_screen_enabled';
export const SKADNETWORK_ACTIVITY_SCREEN = 'skadnetwork_activity_screen';
export const APPEND_WEB_FLIPPER = 'append_web_flipper';
export const DRUID_RATE_LIMIT_MODAL = 'druid_rate_limit_modal';
export const IOS_APP_STORE_AUTHENTICATION = 'ios_app_store_authentication';
export const TIKTOK_AUTH = 'tiktok_auth';
export const IOS14_CALCULATE_ORGANIC_SETTINGS = 'ios14_calculate_organic_settings';
export const SKADNETWORK_FACEBOOK_ENDPOINTS = 'skadnetwork_facebook_endpoints';
export const DISPLAY_COST_ON_SKADNETWORK = 'display_cost_on_skadnetwork';
export const APPLE_OAUTH2 = 'apple_oauth2';
export const HYDRA_OAUTH2 = 'hydra_oauth2';
export const CENARIUS_GENERAL_ENDPOINT_INSTALLS = 'cenarius_general_endpoint_installs';
export const SHOULD_SPLIT_CENARIUS_GENERAL_QUERY = 'should_split_cenarius_general_query';
export const HIGHCHARTS_SUMMARY_PAGE = 'highcharts_summary_page';
export const ENABLE_COST_ON_LINKS_CALCULATIONS = 'enable_cost_on_links_calculations';
export const REDUCED_DEFAULT_FILTER_RANGE_DRUID = 'reduced_default_filter_range_druid';
export const CONVERSION_VALUE_EVENT_ALIAS_MAPPING = 'conversion_value_event_alias_mapping';
export const JOURNEY_PRIORITY_POPOVER = 'journey_priority_popover';
export const JOURNEY_CREATIVES_TAB = 'journey_creatives_tab';
export const JOURNEY_CREATE_FLOW = 'journey_create_flow';
export const CONVERSION_VALUE_EVENT_REVENUE_RANGE_MAPPING = 'conversion_value_event_revenue_range_mapping';
export const SKADNETWORK_AGENCY_PERMISSIONS = 'skadnetwork_agency_permissions';
export const IOS14_CLPBOARD_DEEPVIEWS = 'ios14_clpboard_deepviews';
export const QLT_PERMISSIONS = 'qlt_permissions';
export const ENGAGEMENT_BUILDER_AD_PARTNER_INTEGRATION = 'engagement_builder_ad_partner_integration';
export const EXTEND_CONVERSION_EVENT_WINDOW_DAYS_LIMITS = 'extend_conversion_event_window_days_limits';
export const JOURNEYS_CREATIVES_MICROFRONTEND = 'journeys_creatives_microfrontend';
export const SENTRY_MONITORING = 'sentry_monitoring';
export const FACEBOOK_INSTALL_REFERRER = 'facebook_install_referrer';
export const ENABLE_ADVANCED_CONVERSION_FOR_SNAP = 'enable_advanced_conversion_for_snap';
export const MATCH_CAMPAIGN_ID_FOR_EO_DATA = 'match_campaign_id_for_eo_data';
export const SHOW_DATA_FEEDS_WEBHOOK_HEADERS_AND_BODY = 'show_data_feeds_webhook_headers_and_body';
export const HISTORICAL_MAU_MODAL = 'historical_mau_modal';
export const PRE_CONFIGURED_CUSTOM_EXPORTS = 'pre_configured_custom_exports';
export const ACCESSIBE = 'accessibe';
export const SENTRY_EVERY_REQUEST = 'sentry_every_request';
export const NEW_POSTBACKS_FORM = 'new_postbacks_form';
export const CSP_REPORTING = 'csp_reporting';
export const ANALYTICS_REPORT_PREVIEW = 'analytics_report_preview';
export const ENABLE_TIKTOK_SAN = 'enable_tiktok_san';
export const ENABLE_HUAWEI_AD_PARTNER = 'enable_huawei_ad_partner';
export const ANALYTICS_OVERHAUL_PHASE_ONE = 'analytics_overhaul_phase_one';
export const SUPPORT_LOCAL_CURRENCY = 'support_local_currency';
export const LINK_MANAGER = 'link_manager';
export const NEW_WEBHOOK_PAGE = 'new_webhook_page';
export const UNIFIEDSKANVIEW = 'unifiedskanview';
export const ALERT_NOTIFICATIONS = 'alert_notifications';
export const QR_CODE_DEEPVIEW = 'qr_code_deepview';
export const NEW_POSTBACKS_MACROS = 'new_postbacks_macros';
export const NEW_WEBHOOKS_MACROS = 'new_webhooks_macros';
export const SORTED_COLUMN_SELECTOR = 'sorted_column_selector';
export const QR_CODE_CUSTOMIZATIONS = 'qr_code_customizations';
export const REMOVE_DESKTOP_SMS = 'remove_desktop_sms';
export const VERSIONING_SERVICE = 'versioning_service_integration';
export const SORTED_COLUMN_SELECTOR_MIGRATION = 'sorted_column_selector_migration';
export const CUSTOM_CALCULATIONS = 'custom_calculations';
export const HAS_BACKDATED_EVENTS = 'has_backdated_events';
export const HIGHCHARTS_MIGRATION = 'highcharts_migration';
export const OTT = 'ott';
export const OTT_AD_NETWORK_FILTERING = 'ott_ad_network_filtering';
export const OTT_PARTNER_MANAGEMENT = 'ott_partner_management';
export const OTT_SUMMARY_PAGE = 'ott_summary_page';
export const OTT_ADS_ACTIVITY_PAGE = 'ott_ads_activity_page';
export const OTT_NEW_PARTNER_SEPARATION = 'ott_new_partner_separation';
export const SKAD_NETWORK_SKAN4 = 'skad_network_skan4';
export const LIGHTWEIGHT_FILTERS_ANALYTICS = 'lightweight_filters_analytics';
export const LINKHUB_BULK_CREATION = 'linkhub_bulk_creation'; // deprecated
export const ADS_FRAUD_HIGHCHARTS = 'ads_fraud_highcharts';
export const GOOGLE_ANALYTICS_V4 = 'google_analytics_v4';
export const PROTECTED_DOWNLOADS = 'protected_downloads';
export const USAGE_AND_QUOTAS = 'usage_and_quotas';
export const TEMPLATE_ONLY_ACCESS_CONTROL = 'template_only_access_control';
export const UNDER_MAINTENANCE = 'under_maintenance';
export const FACEBOOK_AEM_SUPPORT = 'facebook_aem_support';
export const DISCO_DASHBOARD = 'disco_dashboard';
export const DISABLE_AMAZON_POSTBACKS = 'disable_a_amazon_ad_partner';
export const AD_LINK_MANAGER = 'ad_link_manager';
export const AD_LINK_TEMPLATES = 'ad_link_templates';
export const BULK_AD_LINKS = 'bulk_ad_links';
export const BULK_QUICK_LINKS = 'bulk_quick_links';
export const QUICK_LINK_MANAGER = 'quick_link_manager';
export const QUICK_LINK_TEMPLATES = 'quick_link_templates';
export const SKAN_SIMPLIFICATION = 'skan_simplification';
export const AD_LINK_TEMPLATES_INTRODUCTION = 'ad_link_templates_introduction';
export const BULK_AD_LINKS_INTRODUCTION = 'bulk_ad_links_introduction';
export const CUSTOM_PARTNER_LIMIT = 'custom_partner_limit';
export const ERROR_HANDLING = 'error_handling';
export const SELF_SERVE_USAGE_WARNINGS = 'self_serve_usage_warnings';
export const RECAPTCHA_FOR_BRANCH_KEY = 'recaptcha_for_branch_key';
export const HIDE_BRANCH_KEY_RECAPTCHA_FOR_VALID_CREDIT_CARD = 'hide_branch_key_recaptcha_for_valid_credit_card';
export const DYNAMIC_ENDPOINT_WHITE_LISTING = 'dynamic_endpoint_white_listing';
export const V3_COHORTS = 'v3_cohorts';
export const COMPARE_V2_V3_COHORTS = 'compare_v2_v3_cohorts';
export const HIDE_LINK_CONFIGURATION_FROM_ONBOARDING = 'hide_link_configuration_from_onboarding';
export const ALLOW_ACCOUNT_CREATION_ON_MX_SERVER_NOT_FOUND = 'allow_account_creation_on_mx_server_not_found';
export const SKADNETWORK_UNDER_MAINTENANCE = 'skadnetwork_under_maintenance';
export const COHORTS_UI_REFRESH = 'cohorts_ui_refresh';
export const EXTENDED_API_LOGGING = 'extended_api_logging';
export const DESKTOP_JOURNEYS = 'desktop_journeys';
export const SUMMARY_PAGE_PRODUCT_TABS_V2 = 'summary_page_product_tabs_v2';
export const RESTRICT_SNAP_REPORTS = 'restrict_snap_reports';
export const JOURNEY_CREATIVES_HTML_EDITOR_TAB = 'journey_creatives_html_editor_tab';
export const COLLECTIONS_CYCLE_2 = 'collections_cycle_2';
export const DELETE_LINK_TEMPLATES = 'delete_link_templates';
export const PENDO_ENABLED = 'pendo_enabled';
export const LIGHTWEIGHT_FILTERS_FOR_EMAIL = 'enable_lightweight_filters_for_email';
export const COST_DATA_INTEGRATION = 'cost_data_integration';
export const DATE_RANGE_PICKER_FILTER_MENU = 'date_range_picker_filter_menu';
export const BRANCH_ACCOUNT_SETTINGS = 'branch_account_settings';
export const CUSTOM_QR_JOURNEYS = 'custom_qr_journeys';
export const QR_CODE_LINK_MANAGER = 'qr_code_link_manager';
export const SKAN_UNIFIED_VIEW_V2 = 'skan_unified_view_v2';
export const ROI_HUB = 'roi_hub';
export const ROI_ANALYTICS = 'roi_analytics';
export const SUPPORT_NBCU_AD_PARTNER = 'support_nbcu_ad_partner';
